import { useState, useEffect } from "react";
import { IUseAutocomplete, TAutocompleteOption } from "../interfaces/form";

export const useAutoComplete = ({
  allOption,
  handleChangeValue,
  fieldKey,
}: IUseAutocomplete) => {
  const [selectedOptions, setSelectedOptions] = useState<TAutocompleteOption[]>(
    [allOption]
  );

  const handleSelectOption = (option: TAutocompleteOption) => {
    const allOptionsSelected = [allOption];
    if (option?.id === allOption.id) {
      setSelectedOptions(allOptionsSelected);
      return;
    }
    const optionAlreadyExists = !!selectedOptions.find(
      ({ id }) => id === option.id
    );
    const filteredOptions = selectedOptions.filter(
      ({ id }) =>
        id !== allOption.id && (optionAlreadyExists ? id !== option.id : true)
    );
    const newSelectedOptions = optionAlreadyExists
      ? filteredOptions
      : [...filteredOptions, option];
    setSelectedOptions(
      newSelectedOptions.length > 0 ? newSelectedOptions : allOptionsSelected
    );
  };

  useEffect(() => {
    const selectedIds = selectedOptions.map(({ id }) => id.toString());
    handleChangeValue(fieldKey, selectedIds);
  }, [selectedOptions]);

  return { selectedOptions, setSelectedOptions, handleSelectOption };
};
